import Axios from "axios";

let axios = Axios.create({
  baseURL: `https://us-central1-growatt-warranty-claim-webform.cloudfunctions.net/api`,
});

export default axios;
